import { Request } from "@xt/xtbase";

const { XtAxios } = Request;
const URL = "/";

export function get_fapiSymbolList(config?) {
  return XtAxios.get(URL + "fapi/market/v1/public/symbol/list", config);
}
